import type { ReactNode } from "react";
import "./PlutusStartupScreen.css";

/** Web version of the mobile BootScreen, using its original wordmark crops. */
export default function PlutusStartupScreen({ children }: { children?: ReactNode }) {
  return (
    <div className="plutus-startup">
      <div className="plutus-startup-gradient" aria-hidden="true" />
      <div className="plutus-startup-lockup" role="status" aria-label="Loading Plutus">
        <img className="plutus-startup-mark" src="https://www.runplutus.com/provider-assets/1/plutus-wordmark-mark-white.png" width="57.024" height="61.632" alt="" />
        <img className="plutus-startup-wordmark" src="https://www.runplutus.com/provider-assets/1/plutus-wordmark-text-white.png" width="169.344" height="61.632" alt="Plutus" />
      </div>
      {children && <div className="plutus-startup-message">{children}</div>}
    </div>
  );
}
